import React from "react";
import ImgPF1 from "../../../assets/images/para-voce/img-PF1@2x.png";
import "../global.scss";
import { Link } from "react-router-dom";

export const TabIntercambio = () => {
  return (
    <div className="tab-content">
      <div className="left">
        <div className="content">
          <h1>Programe seu intercâmbio</h1>
          <p>
            Intercâmbio estudantil para o exterior é uma experiência
            enriquecedora que oferece inúmeras vantagens, desde o aprendizado de
            um novo idioma até o desenvolvimento pessoal e profissional. Para
            que essa experiência seja bem-sucedida, é fundamental um bom
            planejamento. Aqui estão alguns pontos importantes a considerar:
          </p>
        </div>
        <div className="content">
          <h2 className="title">Objetivo</h2>
          <p>
            <span className="title-span">Tipo de intercâmbio: </span>
            Defina o tipo de intercâmbio que deseja: curso de idiomas, high
            school, graduação, pós-graduação, cursos profissionalizantes,
            trabalho voluntário, etc.
          </p>
          <p>
            <span className="title-span">Duração: </span>
            Intercâmbios podem durar de algumas semanas a alguns anos,
            dependendo do programa escolhido.
          </p>
          <p>
            <span className="title-span">Destino: </span>
            Escolha o país e a cidade de destino considerando o idioma que
            deseja aprender, o custo de vida, a cultura local e as oportunidades
            de estudo e lazer.
          </p>
          <p>
            <span className="title-span">Orçamento: </span>
            Calcule os custos com passagens aéreas, acomodação, alimentação,
            transporte, seguro saúde, visto, material didático, lazer e
            imprevistos. Pesquise bolsas de estudo e financiamentos.
          </p>
        </div>
        <div className="content">
          <h2 className="title">Planejamento</h2>
          <p>
            <span className="title-span">Documentação: </span>
            Passaporte válido, visto (se necessário), seguro saúde
            internacional, comprovante de matrícula, carta de aceite da
            instituição de ensino, etc. Verifique os requisitos específicos do
            país de destino.
          </p>
          <p>
            <span className="title-span">Acomodação: </span>
            Escolha entre casa de família, residência estudantil, apartamento
            compartilhado ou apartamento individual. Considere o custo, a
            localização e a conveniência de cada opção.
          </p>
          <p>
            <span className="title-span">Passagens aéreas: </span>
            Compre as passagens com antecedência para garantir melhores preços.
            Considere a flexibilidade das datas para encontrar voos mais baratos
          </p>
          <p>
            <span className="title-span">Seguro saúde: </span>
            Essencial para cobrir despesas médicas e hospitalares durante o
            intercâmbio. Verifique a cobertura do seguro e os procedimentos em
            caso de emergência.
          </p>
          <p>
            <span className="title-span">Dinheiro: </span>
            Leve dinheiro em espécie para os primeiros dias e utilize cartões de
            crédito internacional, cartões de débito internacional ou cartões
            pré-pagos para o restante da viagem. Compare as taxas de câmbio e as
            taxas cobradas pelos bancos e operadoras de cartão.
          </p>
        </div>
      </div>
      <div className="right">
        <img src={ImgPF1} alt="" />
        <div className="vantagens">
          <h2>Vantagens de utilizar a Cobalt</h2>
          <p>
            <span className="title-span">Plataformas de Pagamento Online</span>
            Plataformas como a da Cobalt, que oferecem transferências
            internacionais com taxas, geralmente, mais competitivas que as dos
            bancos tradicionais.
          </p>
          <p>
            <span className="title-span">Transparência</span>
            Aqui na Cobalt, não há taxas escondidas como taxas de saque, taxas
            de conversão e IOF. Todos os custos das transações são informados
            antes do fechamento do câmbio.
          </p>
          <p>
            <span className="title-span">Proteção Cambial</span>O valor recebido
            em moeda local pode variar de acordo com a flutuação da taxa de
            câmbio. Utilizar produtos cambiais, como contratos a termo, pode
            ajudar a mitigar esse risco.
          </p>
          
          <Link to={"/cadastro"} className="btn-abrir-conta">Abra agora a sua conta</Link>
        </div>
      </div>
    </div>
  );
};
